<template>
  <div class="break-word" width="100%">
    <div
      cols="12"
      class="pt-5 pb-2 align-center d-none d-sm-flex"
    >
      <!-- <v-btn
        class="ma-2"
        text
        icon
        color="teal accent-4"
        to="/pettycash_hc_dashboard/dashboard"
      >
        <v-icon x-large>mdi-chevron-left</v-icon>
      </v-btn> -->
      <h3 class="font-weight-bold primary--text x-large">
        {{ document_id }}
      </h3>
    </div>
    <v-card
      class="mx-sm-5 my-sm-0 ma-1 list-nav-hc card-radius-dashboard-power-bi card-height-dashboard-power-bi pt-3 px-0 pb-0 "
      elevation="0"
    >
      <v-col
        cols="12"
        class="py-3 align-center d-flex d-sm-none"
      >
        <!-- <v-btn
          class="my-2"
          text
          icon
          color="teal accent-4"
          to="/pettycash_hc_dashboard/dashboard"
        >
          <v-icon x-large>mdi-chevron-left</v-icon>
        </v-btn> -->
        <h3 class="font-weight-bold primary--text x-large">
          {{ document_id }}
        </h3>
      </v-col>
      <v-row class="justify-center ma-0">
        <v-col
          cols="12"
          sm="auto"
          class="d-flex flex-column justify-start pt-sm-10 pl-10"
        >
          <div v-html="message"></div>
        </v-col>
      </v-row>
      <v-row class="justify-center ma-0">
        <!-- <div
          cols="12"
          sm="auto"
          class=" py-5 py-sm-10 d-flex flex-column align-center"
        >
          <span class="text-decoration-underline">ข้าพเจ้า</span>
          <span>{{name}}</span>
        </div> -->
      </v-row>
      <v-row class="justify-center ma-0 pb-10">
        <div cols="12" class="d-flex justify-center">
          <v-btn
            class="mx-2 elevation"
            width="120px"
            color="primary"
            depressed
            @click="acceptDialog = true"
            :disabled="disbtn"
          >
            <span class="mdi mdi-check"></span> ยอมรับ
          </v-btn>
          <v-btn
            class="mx-2 elevation white-background"
            width="120px"
            depressed
            outlined
            @click="rejectDialog = true"
            :disabled="disbtn"
          >
            <span class="mdi mdi-close"></span> ปฏิเสธ
          </v-btn>
        </div>
      </v-row>
      <v-row class="justify-center ma-0">
        <div class="d-flex  flex-column d-sm-none">
          <span class="text-center text-size"
            >บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)</span
          >
          <span class="text-center text-size"
            >1768 อาคารไทยชัมมิททาวเวอร์ ชั้น IT แขวงบางกะปิ เขตห้วยขวาง</span
          >
          <span class="text-center text-size">กรุงเทพ 10310</span>
        </div>
      </v-row>
    </v-card>

    <template>
      <v-row justify="center">
        <v-dialog v-model="acceptDialog" max-width="500">
          <v-card>
            <v-card-title class="text-h5 d-flex justify-center"
              ><v-icon x-large color="orange darken-2"
                >mdi-alert-outline
              </v-icon>
            </v-card-title>
            <v-card-title class="break-word text-center">
              คุณแน่ใจหรือไม่ว่าต้องการบันทึกข้อมูล
              การยืนยันการตรวจสอบยอดเงินและกดยืนยันการรับเงิน
            </v-card-title>
            <v-card-actions class=" justify-center">
              <v-btn
                class="ma-3 white--text"
                color="success"
                elevation="0"
                @click="acceptDialog = false,approve_transaction('Accept')"
              >
                ยืนยัน
              </v-btn>
              <v-btn
                class="ma-3"
                color="error"
                elevation="0"
                @click="acceptDialog = false"
              >
                ยกเลิก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="rejectDialog" max-width="500">
          <v-card>
            <v-card-title class="break-word text-start">
              กรุณาระบุเหตุผล
              การปฏิเสธการบันทึกข้อมูลการยืนยันการตรวจสอบยอดเงินและยืนยันการรับเงิน
            </v-card-title>
            <v-col cols="12">
              <v-textarea
                outlined
                hide-details
                placeholder="โปรดระบุเหตุผล"
                v-model="detail_reject"
              ></v-textarea>
            </v-col>
            <v-card-actions class=" justify-end">
              <v-btn
                class="white--text"
                color="primary"
                elevation="0"
                @click="rejectDialog = false,approve_transaction('Reject')"
              >
                ส่ง
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<script>
export default {
  data: () => ({
    transaction_id:'',
    message :'',
    name:'',
    disbtn:false,
    document_id:'',
    detail_reject:'',
    texts: [
      {
        id: 1,
        documentType: "ใบเบิกเงินสด",
        withdrawalDate: "3 พฤศจิกายน 2566",
        accountNumber: "xxxxxx1037",
        countOfMoney: "1,600"
      }
    ],
    accounts: [
      {
        id: 1,
        accountId: "PC-256611003048",
        user_name: "นางสาวณัฐชา ฤทธิ์ลอย"
      }
    ],
    acceptDialog: false,
    rejectDialog: false
  }),
  mounted () {
    if(this.$route.query.transaction_id) {
      this.transaction_id = this.$route.query.transaction_id
      this.getMessageApprove(this.transaction_id)
    }
  },
  methods: {
    async getMessageApprove(transaction_id) {
      try {
        //this.name = sessionStorage.getItem('name')
        //this.is_load = true
        this.transaction_id = transaction_id
        const url = this.$api_url + `/petty_cash/api/v1/noti_message_approve?transaction_id=${transaction_id}`;
        const { data } = await this.axios.get(url);
        if (data.status) {
          this.message = data.data.message
          this.document_id = data.data.document_id
          this.disbtn = data.data.status_approve
        }
      } catch (error) {
        console.log(error);
      }
      //this.is_load = false
    },
    async approve_transaction(type) {
        try{
          if(type == 'Accept'){
            this.detail_reject = ''
          }
          let url = this.$api_url + `/petty_cash/api/v1/update_hc_transaction`
          // console.log("type:",type);
          // console.log('url:',url);
          // console.log("detail_reject:",this.detail_reject);
          // console.log('transaction_id:',this.transaction_id);
          let { data } = await this.axios.post(url, {
            type:type,
            transaction_id:this.transaction_id,
            detail: this.detail_reject
          })
          if(data){
            // console.log("data:",data);
            this.disbtn = true
          }
        }catch(error){
          console.log(error)
        }
      },
  }
};
</script>

<style scoped>
.text-size {
  font-size: small;
}

.break-word {
  word-break: break-word;
}

.white-background {
  background-color: #ffffff !important;
}

.card-height-dashboard-power-bi {
  height: 75vh !important;
}
</style>
